export default __webpack_public_path__ + "static/media/SmallSBAcceptableMovementEdited.dc90053c.mp4";